export default {

    methods: {
        downloadFile(data) {
            const newData = Object.assign({responseType: 'blob'}, data)
            return new Promise((resolve => {
                resolve()
            })).then(() => {
                axios(newData).then((response) => {
                    const disposition = response.headers['content-disposition'];
                    let filename;
                    const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    const matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, '');
                    } else {
                        throw new Error('filename could not be parsed');
                    }
                    const fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    const fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', filename);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                })
            });
        },
    },
}
